export default __webpack_public_path__ + "static/supplies-hover-b7696d52e0335804d05c176ef2193a40.png";